export default __webpack_public_path__ + "static/media/mitvc-district-championship-banner.ab44fbf7.jpg";